import { useEffect } from 'react';

const SITE_URL = 'https://www.sidekraft.no';
const SITE_NAME = 'Side Kraft';

/**
 * Profesjonell SEO for hver side. Oppdaterer title, description, canonical, og Open Graph.
 * Bruk: <PageSEO title="Tittel" description="Beskrivelse (155–160 tegn)" path="/side" />
 */
export function PageSEO({ title, description, path = '' }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `Digitalt markedsføringsbyrå Norge | ${SITE_NAME} | SEO & Nettsider`;
  const canonical = path ? `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}` : SITE_URL;
  const ogTitle = title ? `${title} | ${SITE_NAME}` : fullTitle;

  useEffect(() => {
    document.title = fullTitle;

    const updateMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el && value) el.setAttribute(attr, value);
    };

    const ensureMeta = (nameOrProp, content, isProperty = false) => {
      const selector = isProperty ? `meta[property="${nameOrProp}"]` : `meta[name="${nameOrProp}"]`;
      let el = document.querySelector(selector);
      if (!el && content) {
        el = document.createElement('meta');
        if (isProperty) el.setAttribute('property', nameOrProp);
        else el.setAttribute('name', nameOrProp);
        document.head.appendChild(el);
      }
      if (el && content) el.setAttribute('content', content);
    };

    if (description) {
      ensureMeta('description', description);
      ensureMeta('og:description', description, true);
      ensureMeta('twitter:description', description);
    }
    ensureMeta('og:title', ogTitle, true);
    ensureMeta('twitter:title', ogTitle);
    ensureMeta('og:url', canonical, true);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = canonical;
  }, [fullTitle, description, ogTitle, canonical]);

  return null;
}
